module.exports = {
    userAccesses:
    [   
        {
            name: 'Hub',
            key: 'hub',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access the hub'
                },
                {
                    key: 'create',
                    name: 'Create',
                    description: 'Permission to create a stream'
                },
                {
                    key: 'edit',
                    name: 'Edit',
                    description: 'Permission to edit hub layout'
                }
            ],
            description: 'Hub permissions'
        },
        {
            name: 'Collection',
            key: 'collection',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access collections'
                },
                {
                    key: 'create',
                    name: 'Create',
                    description: 'Permission to create a collection'
                },
                {
                    key: 'collaborate',
                    name: 'Collaborate',
                    description: 'Permission to collaborate a collection'
                },
                {
                    key: 'template',
                    name: 'Mark as Template',
                    description: 'Permission to mark a collection as a template'
                }
            ],
            description: 'Collection permissions'
        },
        {
            name: 'Conversations',
            key: 'conversation',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access conversations'
                }
            ],
            description: 'Conversation permissions'
        },
        {
            name: 'Deal Room',
            key: 'dealRoom',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access deal rooms'
                },
                {
                    key: 'create',
                    name: 'Create',
                    description: 'Permission to create a deal room'
                },
                {
                    key: 'collaborate',
                    name: 'Collaborate',
                    description: 'Permission to collaborate a deal room'
                }
            ],
            description: 'Deal room permissions'
        },
        {
            name: 'Engage',
            key: 'engage',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access the \'Engage\' module and interact with recipients.'
                },
                {
                    key: 'globalEngage',
                    name: 'Access all recipients',
                    description: 'Permission to view interactions with all recipients of your Organisation.'
                },
                {
                    key: 'viewOnly',
                    name: 'View only',
                    description: 'View only access to prior interactions with the users\' direct recipients.'
                },
                {
                    key: 'block',
                    name: 'Block recipients',
                    description: 'Ability to block select recipients from interacting with anyone in your Organization.'
                }
            ],
            description: 'Collection permissions'
        },
        {
            name: 'Contacts',
            key: 'contact',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access contacts'
                },
                {
                    key: 'create',
                    name: 'Create',
                    description: 'Permission to create a contact'
                }
            ],
            description: 'Contacts permissions'
        },
        {
            name: 'Reports',
            key: 'report',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access reports'
                },
                {
                    key: 'download',
                    name: 'Download',
                    description: 'Permission to download reports'
                },
                {
                    key: 'restricted',
                    name: 'Restricted',
                    description: 'Restrict to access reports only of user groups the user is part of'
                }
            ],
            description: 'Reports permissions'
        },
        {
            name: 'Share',
            key: 'share',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access share'
                },
            ]
        },
        {
            name: 'Asset',
            key: 'asset',
            permissions: [
                {
                    key: 'download',
                    name: 'Download',
                    description: 'Permission to download'
                },
                {
                    key: 'create',
                    name: 'Create',
                    description: 'Permission to create asset'
                }
            ]
        },
        {
            name: 'Search',
            key: 'search',
            permissions: [
                {
                    key: 'access',
                    name: 'Access',
                    description: 'Permission to access search'
                },
            ]
        },
        {
            name: 'Settings Management',
            key: 'settingsManagement',
            permissions: [
                {
                    key: 'userManagement',
                    name: 'User Management',
                    description: 'Permission to access User Management'
                },
                {
                    key: 'accountManagement',
                    name: 'Account Management',
                    description: 'Permission to access Account Management'
                },
                {
                    key: 'datasourceManagement',
                    name: 'Content Sources',
                    description: 'Permission to access Content Sources'
                },
                {
                    key: 'integrations',
                    name: 'Integrations',
                    description: 'Permission to access Integrations'
                },
                {
                    key: 'customFields',
                    name: 'Custom Fields',
                    description: 'Permission to access CustomFields'
                },
                {
                    key: 'emailTemplates',
                    name: 'Email Templates',
                    description: 'Permission to access Email Templates'
                },
                {
                    key: 'notifications',
                    name: 'Notifications',
                    description: 'Permission to access Notifications'
                },
                {
                    key: 'ndaTemplates',
                    name: 'NDA Templates',
                    description: 'Permission to access NDA Templates'
                },
                {
                    key: 'privacyPolicyControl',
                    name: 'Privacy Policy Control',
                    description: 'Permission to access Privacy Policy Control'
                },
            ]
        },
        {
            name: 'Billing',
            key: 'billing',
            permissions: [
                {
                    key: 'accessInvoice',
                    name: 'Access Invoice',
                    description: 'Permission to access payment history'
                },
            ],
            description: 'Billing permissions'
        }
    ]
};

